(() => {
  const config = document.querySelector('[data-daisy-restock-config]');
  if (!config) return;
  const settings = JSON.parse(config.textContent);
  let discountAmount = 0;
  window.DaisyRestockOffer = {
    discountedPrice(cents) {
      return discountAmount && Number.isFinite(cents) && cents >= discountAmount ? cents - discountAmount : null;
    },
    formatPrice(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD',
        minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    },
  };
  if (settings.currency !== 'USD') return;
  const signupCode = (settings.signupCode || '').toLowerCase();
  const params = new URLSearchParams(location.search);
  const fromSignupEmail = (params.get('offer') || '').toLowerCase() === 'daisy10';
  const fromEmail = settings.enabled && (params.get('offer') || '').toLowerCase() === 'restock26';
  let requestId = 0;
  const setDiscount = value => {
    discountAmount = value;
    document.dispatchEvent(new CustomEvent('daisy:restock-offer-ready'));
  };
  // The cart, not a URL or remembered signup, determines displayed sale pricing.
  const refresh = async (applyCode = '') => {
    const id = ++requestId;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(`${settings.root}${applyCode ? 'cart/update.js' : 'cart.js'}`, applyCode ? {
        method: 'POST', credentials: 'same-origin',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: applyCode }),
      } : { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (id !== requestId) return;
      const codes = (cart.discount_codes || []).filter(item => cart.item_count === 0 || item.applicable === true);
      const hasCode = code => code && codes.some(item => item.code?.toLowerCase() === code);
      const amount = hasCode(signupCode) ? 3500 : settings.enabled && hasCode('restock26') ? 5000 : 0;
      setDiscount(cart.currency === 'USD' ? amount : 0);
      if (applyCode && hasCode(applyCode.toLowerCase())) {
        const url = new URL(location.href);
        url.searchParams.delete('offer');
        history.replaceState(history.state, '', url);
      }
    } catch { if (id === requestId) setDiscount(0); }
    finally { clearTimeout(timeout); }
  };
  refresh(fromSignupEmail ? signupCode : fromEmail ? 'Restock26' : '');
  document.addEventListener('daisy:signup-offer-applied', () => refresh());
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => refresh());
  }
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  window.addEventListener('focus', () => refresh());
})();
